export default "__VITE_ASSET__Cu1LoN0U__"